import {lazy} from 'react';

export const SpecialistRoomsAsync = lazy(() =>
    import('./SpecialistRooms')
);
